import * as React from 'react'
import type { AidaChatValue } from '../hooks/use-aida-chat'

export const AidaChatContext = React.createContext<AidaChatValue | null>(null)

export function useAidaChat() {
  const chat = React.useContext(AidaChatContext)
  if (!chat) {
    throw new Error('useAidaChat must be used within AidaChat')
  }
  return chat
}
